module.exports = __webpack_public_path__ + "static/Gary-e4f8220e8d2632aa7f35bdaa94f70572.jpg";